<template>
  <div
    :id="$attrs._id"
    class="tag-basic-icon"
    :class="{ 'tag-basic-icon--box-shadow': boxShadow !== false }"
    :style="[
      styles,
      {
        '--tag-bg-color': backgroundColour,
        '--tag-text-color': textColour
      }
    ]"
  >
    <fa class="tag-basic-icon__icon" :icon="['fad', faIcon]" />
    <div
      class="tag-basic-icon__label"
      v-html="label[activeLanguage.code]"
    ></div>
  </div>
</template>
<script>
export default {
  props: [
    "pos",
    "label",
    "icon",
    "background-colour",
    "text-colour",
    "box-shadow"
  ],

  computed: {
    activeLanguage() {
      return this.$store.getters.activeLanguage;
    },

    faIcon() {
      return this.icon || "car";
    },

    styles() {
      return {
        // divide by font size
        left: `${this.pos.x / 20}em`,
        top: `${this.pos.y / 20}em`
      };
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/styles/_variables.scss";

.tag-basic-icon {
  background-color: var(--tag-bg-color, $basic-icon-tag-bg-color);
  border-radius: 50%;
  box-shadow: none;
  color: var(--tag-text-color, $white);
  display: flex;
  font-family: $touchscreen-font;
  font-size: 1em;
  height: 2.5em;
  letter-spacing: 0.05em;
  line-height: 1.2em;
  padding: 0;
  cursor: pointer;
  pointer-events: auto;
  position: absolute;
  transition: opacity 200ms ease-in-out, box-shadow 200ms ease-in-out;
  width: 2.5em;
  z-index: 5;

  &.inactive {
    opacity: 0.5 !important;
  }

  &::before {
    background: var(--tag-bg-color, $basic-icon-tag-bg-color);
    bottom: 100%;
    box-shadow: none;
    content: "";
    height: 2.5em;
    left: 50%;
    position: absolute;
    transform: translateX(-50%);
    width: 0.25em;
  }

  &__label {
    background-color: var(--tag-bg-color, $basic-icon-tag-bg-color);
    border-radius: $basic-icon-tag-border-radius;
    box-shadow: none;
    color: var(--tag-text-color, $basic-icon-tag-font-color);
    font-family: $touchscreen-font;
    font-size: $basic-icon-tag-font-size;
    font-weight: 300;
    left: 50%;
    letter-spacing: 0.1em;
    line-height: 1.2em;
    width: max-content;
    padding: 0.4em 1.2em 0.2em;
    pointer-events: auto;
    position: absolute;
    text-align: center;
    text-transform: uppercase;
    transform: translate(-50%, -5em);
    user-select: none;
  }

  &__icon {
    font-size: 1.5em;
    margin: auto;
  }

  &--box-shadow {
    box-shadow: $tag-box-shadow;

    &::before {
      box-shadow: $tag-box-shadow;
    }

    .tag-basic-icon__label {
      box-shadow: $tag-box-shadow;
    }
  }
}
</style>
